import React from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Navbar from './components/Navbar'
import './App.css'
import HomePage from './components/HomePage'
import Footer from './components/Footer'
import { HashRouter, Route, Router, Routes } from 'react-router-dom'
import ThankYouPage from './Pages/ThankYouPage'
import AboutUs from './Pages/AboutUs'
import ContactUs from './Pages/ContactUs'
import WhySSS from './components/WhySSS'
import ComputerScience from './Pages/ComputerScience'
import BestCoachingGhazipur from './Pages/BestCoachingGhazipur'
import MathsTuitionGhazipur from './Pages/MathsTuitionGhazipur'
import ScienceTuitionGhazipur from './Pages/ScienceTuitionGhazipur'
import CBSECoachingGhazipur from './Pages/CBSECoachingGhazipur'
import Class9CoachingGhazipur from './Pages/Class9CoachingGhazipur'
import Class10CoachingGhazipur from './Pages/Class10CoachingGhazipur'
import UnderConstruction from './components/UnderConstruction'
import PrivacyPolicy from './Pages/PrivacyPolicy'  
import CourseOverviewSection from './Pages/Courses'
import TermsAndConditions from './Pages/TermsAndCondition'
import FacultyPage from './Pages/FacultyPage'
import Gallery from './Pages/Gallary'
import Class8Foundation from './Pages/Class8Foundation'
import CourseDetailPage from './Pages/CourseDetailPage'
import Class9Foundation from './Pages/Class9Foundation'
import Class10BoardPrep from './Pages/Class10Foundation.jsx'
import Class11Foundation from './Pages/Class11Foundation'
import Class12BoardPrep from './Pages/Class12Foundation'
import Admissions2026 from './Pages/Admissions2026.jsx'
import AnnouncementMarquee from './components/AnnouncementMarquee.jsx'
import CancellationRefund from './Pages/CancellationRefund.jsx'
import OnlineClass10TuitionGhazipur from './Pages/OnlineClass10TuitionGhazipur'
import Class1112ScienceCoachingGhazipur from './Pages/Class1112ScienceCoachingGhazipur'
import CoachingCentreNearMeGhazipur from './Pages/CoachingCentreNearMeGhazipur'

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", sans-serif',
  },
})

const App = () => {
  return (
    <ThemeProvider theme={theme}>
    <div>
      <Navbar />
      <AnnouncementMarquee/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/whySSS" element={<WhySSS />} />
        <Route path="/courses/computer-science" element={<ComputerScience />} />
        <Route path="/best-coaching-ghazipur" element={<BestCoachingGhazipur />} />
        <Route path="/maths-tuition-ghazipur" element={<MathsTuitionGhazipur />} />
        <Route path="/science-tuition-ghazipur" element={<ScienceTuitionGhazipur />} />
        <Route path="/cbse-coaching-ghazipur" element={<CBSECoachingGhazipur />} />
        <Route path="/class-9-coaching-ghazipur" element={<Class9CoachingGhazipur />} />
        <Route path="/class-10-coaching-ghazipur" element={<Class10CoachingGhazipur />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="*" element={<UnderConstruction />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faculty" element={<FacultyPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/courses" element={<CourseOverviewSection />} />
        {/* <Route path="/apply-online" element={<AdmissionForm />} /> */}
        <Route path="/detail-page" element={<CourseDetailPage />} />
        <Route path="/courses/class-8-foundation" element={<Class8Foundation />} />
        <Route path="/courses/class-9-foundation" element={<Class9Foundation />} />
        <Route path="/courses/class-10-board-preparation" element={<Class10BoardPrep />} />
        <Route path="/courses/class-11-foundation" element={<Class11Foundation />} />
        <Route path="/courses/class-12-board-preparation" element={<Class12BoardPrep />} />
        <Route path="/admission-open" element={<Admissions2026 />} />
        <Route path="/cancellation-refund" element={<CancellationRefund />} />
        <Route path="/online-class-10-tuition-ghazipur" element={<OnlineClass10TuitionGhazipur />} />
        <Route path="/class-11-12-science-coaching-ghazipur" element={<Class1112ScienceCoachingGhazipur />} />
        <Route path="/coaching-centre-near-me-ghazipur" element={<CoachingCentreNearMeGhazipur />} />
      </Routes>
      <Footer />
    </div>
    </ThemeProvider>
  )
}

export default App
